<template>
  <div class="business-type-page">
    <div class="toolbar">
      <Button color="primary" @click="openCreate" icon="h-icon-plus">新增业务类型</Button>
    </div>
    <Table :datas="list" :loading="loading" stripe>
      <TableItem title="ID" prop="id" align="center" :width="80"></TableItem>
      <TableItem title="业务类型名称" prop="title" align="center"></TableItem>
      <TableItem title="发票类型" align="center" :width="120">
        <template slot-scope="{data}">
          <span :class="data.invoiceType === 0 ? 'text-primary' : 'text-success'">
            {{ getInvoiceTypeText(data.invoiceType) }}
          </span>
        </template>
      </TableItem>
      <TableItem title="凭证字" prop="voucherWord" align="center" :width="120"></TableItem>
      <TableItem title="操作" align="center" :width="180">
        <template slot-scope="{data}">
          <Button text color="primary" @click="openEdit(data)">编辑</Button>
          <Button text color="red" @click="remove(data)">删除</Button>
        </template>
      </TableItem>
    </Table>

    <!-- 新增/编辑弹窗 -->
    <Modal v-model="showModal" :hasCloseIcon="true" :middle="true" :width="600" class="business-type-modal">
      <div class="modal-header" :class="isEdit ? 'modal-header-edit' : 'modal-header-create'">
        <div class="modal-title">{{ isEdit ? '编辑业务类型' : '新增业务类型' }}</div>
      </div>
      <Form ref="form" :model="form" :rules="rules" labelPosition="right" :labelWidth="110">
        <FormItem label="业务类型名称" prop="title" class="form-item">
          <Input v-model="form.title" placeholder="如：销售收入、采购成本" />
        </FormItem>
        <FormItem label="发票类型" prop="invoiceType" class="form-item">
          <Select v-model="form.invoiceType" :datas="invoiceTypes" placeholder="请选择发票类型" />
        </FormItem>
        <FormItem label="凭证字" class="form-item">
          <Input v-model="form.voucherWord" placeholder="如：记" />
        </FormItem>
        <FormItem label="科目配置" class="form-item form-item-textarea">
          <textarea v-model="form.items" rows="4" placeholder='{"subjectId": 1001, "subjectName": "主营业务收入"}' class="custom-textarea"></textarea>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button color="primary" @click="save">保存</Button>
        <Button @click="showModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import businessTypeApi from '../../api/invoicebusinesstype';

export default {
  name: 'InvoiceBusinessType',
  data() {
    return {
      list: [],
      loading: false,
      showModal: false,
      isEdit: false,
      form: {
        title: '',
        invoiceType: 0,
        voucherWord: '',
        items: ''
      },
      invoiceTypes: [
        { title: '销项发票', key: 0 },
        { title: '进项发票', key: 1 }
      ],
      rules: {
        title: [{ required: true, message: '请输入业务类型名称' }],
        invoiceType: [{ required: true, message: '请选择发票类型' }]
      }
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const result = await businessTypeApi.getBusinessTypes();
        if (result && result.success && Array.isArray(result.data)) {
          this.list = result.data;
        } else {
          this.list = [];
          console.error('API 返回数据格式错误:', result);
        }
      } catch (e) {
        console.error('加载业务类型失败:', e);
        this.list = [];
      } finally {
        this.loading = false;
      }
    },
    openCreate() {
      this.isEdit = false;
      this.form = {
        title: '',
        invoiceType: 0,
        voucherWord: '',
        items: ''
      };
      this.showModal = true;
    },
    openEdit(data) {
      this.isEdit = true;
      this.form = {
        id: data.id,
        title: data.title,
        invoiceType: data.invoiceType,
        voucherWord: data.voucherWord || '',
        items: data.items || ''
      };
      this.showModal = true;
    },
    async save() {
      const valid = await this.$refs.form.valid();
      if (!valid) return;

      try {
        const data = { ...this.form };
        if (data.items) {
          try {
            JSON.parse(data.items);
          } catch (e) {
            this.$Message.error('科目配置格式不正确，请检查JSON格式');
            return;
          }
        }

        if (this.isEdit) {
          await businessTypeApi.updateBusinessType(data.id, data);
        } else {
          await businessTypeApi.createBusinessType(data);
        }
        this.showModal = false;
        this.$Message.success('保存成功');
        this.load();
      } catch (e) {
        this.$Message.error(e.msg || e.message || '保存失败');
      }
    },
    async remove(data) {
      if (!confirm(`确认删除业务类型 "${data.title}"？`)) return;
      try {
        await businessTypeApi.deleteBusinessType(data.id);
        this.$Message.success('删除成功');
        this.load();
      } catch (e) {
        this.$Message.error(e.msg || e.message || '删除失败');
      }
    },
    getInvoiceTypeText(type) {
      const map = { 0: '销项', 1: '进项' };
      return map[type] || '未知';
    }
  }
};
</script>

<style scoped>
.business-type-page {
  padding: 20px;
}
.toolbar {
  margin-bottom: 16px;
}
.toolbar button {
  margin-right: 8px;
}
.text-primary { color: #1890ff; }
.text-success { color: #52c41a; }

/* 弹窗头部 */
.modal-header {
  margin: -20px -20px 24px -20px;
  padding: 16px 24px;
}
.modal-header-create {
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
}
.modal-header-edit {
  background: linear-gradient(135deg, #722ed1 0%, #531dab 100%);
}
.modal-title {
  font-size: 17px;
  font-weight: 600;
  color: #fff;
  line-height: 1.4;
}

/* 表单样式 */
.form-item :deep(.h-form-item) {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  padding-top: 0 !important;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  min-height: 40px;
}
.form-item-textarea :deep(.h-form-item) {
  align-items: flex-start;
  min-height: auto;
}
.form-item :deep(.h-form-item-error-msg) {
  display: none !important;
}
.form-item :deep(.h-form-item-label) {
  font-size: 15px;
  font-weight: normal;
  color: #595959;
  padding-right: 8px;
  text-align: right;
  white-space: nowrap;
  flex-shrink: 0;
  width: 110px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  line-height: 40px;
}
.form-item-textarea :deep(.h-form-item-label) {
  height: auto;
  padding-top: 8px;
  line-height: 1.5;
}
.form-item :deep(.h-form-item-content) {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  height: 40px;
}
.form-item-textarea :deep(.h-form-item-content) {
  height: auto;
}
.form-item :deep(.h-input),
.form-item :deep(.h-select) {
  width: 100%;
  height: 40px;
  font-size: 15px;
  flex: 1;
}
.form-item :deep(.h-input input) {
  height: 40px;
  font-size: 15px;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  padding: 0 12px;
  transition: all 0.2s ease;
  background: #fafafa;
}
.form-item :deep(.h-input input:focus) {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
  background: #fff;
}
.form-item :deep(.h-input input:hover) {
  border-color: #40a9ff;
  background: #fff;
}
.form-item :deep(.h-select .h-select-show) {
  height: 40px !important;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  transition: all 0.2s ease;
  background: #fafafa;
}
.form-item :deep(.h-select .h-select-show:hover) {
  border-color: #40a9ff;
  background: #fff;
}
.form-item :deep(.h-select .h-select-show.h-select-focus) {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
  background: #fff;
}
.custom-textarea {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #fafafa;
  resize: vertical;
  transition: all 0.2s ease;
  outline: none;
  font-family: inherit;
  line-height: 1.5;
}
.custom-textarea:hover {
  border-color: #40a9ff;
  background: #fff;
}
.custom-textarea:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
  background: #fff;
}

/* 弹窗整体样式 */
:deep(.business-type-modal .h-modal) {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}
:deep(.business-type-modal .h-modal-body) {
  padding: 0 24px 16px 24px;
}
:deep(.business-type-modal .h-modal-footer) {
  border-top: 1px solid #f0f0f0;
  padding: 14px 24px;
  background: #fafafa;
  display: flex;
  justify-content: center;
  gap: 12px;
}
:deep(.business-type-modal .h-modal-footer .h-btn) {
  padding: 0 28px;
  height: 38px;
  font-size: 14px;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s ease;
  min-width: 100px;
}
:deep(.business-type-modal .h-modal-footer .h-btn-primary) {
  background: linear-gradient(135deg, #1890ff, #096dd9);
  border: none;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.35);
}
:deep(.business-type-modal .h-modal-footer .h-btn-primary:hover) {
  background: linear-gradient(135deg, #40a9ff, #1890ff);
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.45);
  transform: translateY(-1px);
}
:deep(.business-type-modal .h-modal-footer .h-btn:not(.h-btn-primary)) {
  background: #fff;
  border: 1px solid #d9d9d9;
  color: #595959;
}
:deep(.business-type-modal .h-modal-footer .h-btn:not(.h-btn-primary):hover) {
  border-color: #1890ff;
  color: #1890ff;
}
</style>
